import { isClientSide } from "@src/app/helper/utils";
import { BAASResponse } from "@typings/MyBH";

export const myBHDataTracker = (tags: BAASResponse[]) => {
  if (!isClientSide) return;
  if (typeof window._data === "undefined") return;

  const userKeywords = tags.map((t) => t.name.toLowerCase()).join("|");
  window._data.user_keyword = userKeywords;
};
